import $ from 'jquery';
import ctaTypes from './cta.types';

var __type = ctaTypes['dealerDirections']; // eslint-disable-line dot-notation
function __mapUrl(address) {
  return `https://maps.google.com/?daddr=${address}`;
}

export default function ($scope, dealerAddress) {
  var $ctaScope = $scope || $('body');
  var $ctas = $("a[data-destination='" + __type + "']", $ctaScope);

  if (!$ctas.length) return;

  $ctas.each(function () {
    $(this).attr({ href: __mapUrl(dealerAddress) });
  });
};
